import React, { useEffect, useState } from "react";
import { Col, Container, Form, ListGroup, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { Formik } from "formik";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { CREATE_NOTES, NOTES_TABLE, SCHOOL_CLIENT_DETAIL, SCHOOL_CLIENT_LIST, WORKSHOPS } from "config/paths";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { Breadcrumbs, CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { successMessageToast, userFullName } from "helpers/common";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import LoadingOverlay from "components/shared/LoadingOverlay";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import LoadingButton from "components/shared/LoadingButton";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { User, UserX } from "react-feather";
import { useCreateNoteMutation, useNoteViewQuery, useUpdateNoteMutation } from "store/services/V2/notes";
import AddNotesCollaboratorsModal from "components/Modals/AddNotesCollaborators";
import { useSelector } from "react-redux";
import { useCreateWorkshopMutation, useUpdateWorkshopMutation, useWorkshopViewQuery } from "store/services/workshop";
import workshopSchema from "./validation";
import AddWorkshopCollaboratorsModal from "components/Modals/AddWorkshopCollaboratos";
import { DeleteIcon } from "Assets/icons";
import confirmDialogV2 from "utils/confirmationDialogV2";


const AddWorkshop = () => {

    const navigate = useNavigate();
    const { id: workshopId } = useParams();
    const profile = useSelector((state) => state?.auth?.user)
    const [haveAccess, setHaveAccess] = useState(false)
    const [isOwner, setIsOwner] = useState(true)
    const [editSuggestionId, setEditSuggestionId] = useState(null)
    const [deleteSuggestionId, setDeleteSuggestionId] = useState(null)
    const [isNoteEdit, setIsNoteEdit] = useState(false)

    const breadcrumbItems = [
        { label: "Workshops", path: WORKSHOPS },
        { label: workshopId ? "Edit" : "Add" },

    ];

    const [initialValues, setInitialValues] = useState({ title: '', description: '', date: null, link: "" });
    const [showModal, setShowModal] = useState(false);

    const [createWorkshop, { isLoading: createWorkshopLoading }] = useCreateWorkshopMutation();
    const [updateWorkshop, { isLoading: updateWorkshopLoading }] = useUpdateWorkshopMutation();
    const { data: workshopData, isFetching: workshopDataFetching } = useWorkshopViewQuery({ workshopId }, { skip: !workshopId })

    const handleSubmit = async (values, { resetForm }) => {
        const data = {
            title: values?.title,
            link: values?.link,
            description: values?.description,
            date: values?.date,
            collaboratorData: values?.therapistData?.length > 0 ? values?.therapistData?.map((item) => item?.user_id || item?.id) : []
        }
        try {
            const result = workshopId ? await updateWorkshop({ data, workshopId }).unwrap() : await createWorkshop({ data }).unwrap();
            successMessageToast(result?.message);
            navigate(WORKSHOPS);
        } catch (error) {
            console.error("Error creating note:", error);
        }
    };

    const handleDeleteCollaborator = async (e, values, id, setFieldValue) => {
        e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: `REMOVE`,
            message: `Are you sure you want to remove this collaborator?`,
        });
        if (!isConfirm) {
            return;
        }
        else {
            if (workshopId) {
                const data = {
                    title: values?.title,
                    link: values?.link,
                    description: values?.description,
                    date: values?.date,
                    collaboratorData: values?.therapistData?.filter((item) => item?.user_id != id)?.map((x) => x?.user_id)
                }
                try {
                    await updateWorkshop({ data, workshopId }).unwrap();
                } catch (err) {
                    console.error("Error submitting:", err);
                }
            }
            else {
                const filteredTherapists = values?.therapistData?.filter((item) => item?.id != id);
                setFieldValue('therapistData', filteredTherapists)
                // handleClose()
            }
        }

    };


    useEffect(() => {
        if (workshopData) {
            setInitialValues((prev) => ({
                ...prev,
                title: workshopData?.title || "",
                link: workshopData?.link || "",
                description: workshopData?.description || "",
                date: workshopData?.date,
                therapistData: workshopData?.collaborators?.length ? workshopData?.collaborators : []
            }))
        }
        if (workshopData) {
            workshopData?.workshopOwner?.id != profile?.id ? setIsOwner(false) : setIsOwner(true)
        }
    }, [workshopData])

    return (
        <>
            {/* <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        type="delete"
        confirmHandler={handleDelete}
      /> */}
            <section className={`${styles.addForm} position-relative py-4 addForm h-100`}>
                <Container className="h-100">

                    <Row className="">
                        <Col lg="6">
                            <Breadcrumbs items={breadcrumbItems} />
                        </Col>
                    </Row>
                    { <Row className="h-100">
                        <Col lg="12" className="my-2">
                            {workshopDataFetching && <LoadingOverlay />}
                            <Formik
                                initialValues={initialValues}
                                validationSchema={workshopSchema}
                                onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {({
                                    handleSubmit,
                                    setFieldValue,
                                    isSubmitting,
                                    errors,
                                    values,
                                    touched,
                                    setFieldTouched
                                }) => (
                                    <>
                                    {console.log("Values of frormik ", values)}
                                        <AddWorkshopCollaboratorsModal
                                            show={showModal}
                                            setShow={setShowModal}
                                            therapists={values?.therapistData || []}
                                        />
                                        <Form onSubmit={handleSubmit}>
                                            <div className="reports-v2">
                                                <div className=" d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                                                    {/* <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{editMode ? "Edit TEMPLATES" : "SAVE A TEMPLATES"}</h6> */}
                                                </div>
                                                <Row >
                                                    <Col md="12" className="my-2 name-input-v2">
                                                        <div style={{ borderBottom: "2px solid gray" }} className="pb-3 d-flex align-items-baseline gap-5">
                                                            <div className="w-100">
                                                                <AppInputField
                                                                    name="title"
                                                                    style={{ minHeight: "40px" }}
                                                                    className={`${styles.formControl} readonly-box h-auto`}
                                                                    styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                                                                />
                                                            </div>
                                                            <div className="btnWrpper mt-2 d-flex justify-content-end">
                                                                <button
                                                                    type="submit"
                                                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                                                    disabled={isSubmitting || updateWorkshopLoading || createWorkshopLoading || workshopDataFetching}
                                                                // isLoading={submitReportLoading || submitting}
                                                                >
                                                                    {(isSubmitting || updateWorkshopLoading || createWorkshopLoading) ? <LoadingIndicator /> : "Save"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="6" className="my-2 name-input-v2">
                                                        <label
                                                            htmlFor=""
                                                            className="discharge-screen-label mt-0"
                                                        >
                                                            Link
                                                        </label>
                                                        <AppInputField
                                                            name="link"
                                                            placeholder="https://"
                                                            className={`${styles.formControl} readonly-box h-auto`}
                                                            styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                                                        />
                                                    </Col>
                                                    <Col md="3" className="my-2 name-input-v2">
                                                        <label
                                                            htmlFor=""
                                                            className="discharge-screen-label mt-0"
                                                        >
                                                            Date Created
                                                        </label>
                                                        <AppDatePicker
                                                            name="date"
                                                            className={`${styles.formControl} readonly-box h-auto`}
                                                            styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                                                            placeholder="Enter lesson name"
                                                        />
                                                    </Col>
                                                    <Col md="6" className="mt-2">
                                                        <label
                                                            htmlFor=""
                                                            className="discharge-screen-label mt-0"
                                                        >
                                                            Description
                                                        </label>
                                                        <div className="editor-paren-v2">
                                                            <CustomEditor style={{ borderRadius: 0 }} name={`description`} />
                                                        </div>
                                                    </Col>

                                                    <Col md="4" className="mt-2">
                                                        <div style={{ borderTop: "1px solid rgb(94 122 162)", paddingTop: "23px" }} className="editor-paren-v2">
                                                            <div style={{ width: "250px" }}>
                                                                <h6 className="mb-3 fw-semibold">Collaborators</h6>
                                                                <ListGroup variant="flush">
                                                                    {values?.therapistData?.map((item, index) => (
                                                                        <ListGroup.Item key={index} className="border-0 px-0 py-2">
                                                                            <table className="w-100">
                                                                                <tbody>
                                                                                    <tr>
                                                                                        {/* User info */}
                                                                                        <td className="align-middle">
                                                                                            <div className="d-flex align-items-center gap-2">
                                                                                                {(item?.user?.therapist_detail?.profile_picture ||
                                                                                                    item?.therapist_detail?.profile_picture) ? (
                                                                                                    <img
                                                                                                        src={
                                                                                                            item?.user?.therapist_detail?.profile_picture ||
                                                                                                            item?.therapist_detail?.profile_picture
                                                                                                        }
                                                                                                        alt=""
                                                                                                        className="img-fluid object-fit-cover rounded-circle border border-white"
                                                                                                        style={{ width: 30, height: 30 }}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <User size={24} className="text-secondary" />
                                                                                                )}

                                                                                                <span>{userFullName(item?.user || item)}</span>
                                                                                            </div>
                                                                                        </td>

                                                                                        {/* Delete button */}
                                                                                        {isOwner && (
                                                                                            <td className="cursor-pointer align-middle text-end" style={{ width: "40px" }}>
                                                                                                <DeleteIcon
                                                                                                    onClick={(e) =>
                                                                                                        handleDeleteCollaborator(
                                                                                                            e,
                                                                                                            values,
                                                                                                            workshopId ? item?.user_id : item?.id,
                                                                                                            setFieldValue
                                                                                                        )
                                                                                                    }
                                                                                                />
                                                                                            </td>
                                                                                        )}
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </ListGroup.Item>

                                                                    ))}

                                                                </ListGroup>
                                                                <div
                                                                    onClick={() => {
                                                                        if (workshopData?.workshopOwner?.id == profile?.id || isOwner || !workshopId) setShowModal(true);
                                                                    }}
                                                                    style={{
                                                                        border: "1px solid #93278F",
                                                                        padding: "10px 12px",
                                                                        marginTop: "10px",
                                                                        cursor: workshopId ? (workshopData?.workshopOwner?.id == profile?.id || isOwner) ? "pointer" : "not-allowed" : "pointer",
                                                                        opacity: workshopId ? (workshopData?.workshopOwner?.id == profile?.id || isOwner) ? 1 : 0.5 : 1,
                                                                        pointerEvents: workshopId ? (workshopData?.workshopOwner?.id == profile?.id || isOwner) ? "auto" : "none" : "auto",
                                                                    }}
                                                                >
                                                                    <h2 className="themePurple mb-0 proxima-regular forteen text-center">
                                                                        Add/Manage Collaborators
                                                                    </h2>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Form>
                                    </>
                                )}
                            </Formik>
                        </Col>
                    </Row>}
                </Container>
            </section>
        </>
    );
};

export default AddWorkshop;
